<template>
    <div>
        <div class="user_right">
            <div class="ov lh35">
                <h1 class="urs_h1" style="float:left">添加收货地址</h1>
                <span class="right c9" style="font-size:16px;">
                    <a href="javascript:;" @click="$router.push({path: '/user_address'})">返回列表</a>
                </span>
            </div>
            <div>
                <table width="100%" border="0" class="p_td">
                    <tbody>
                        <tr>
                            <td width="90">收&nbsp;&nbsp;件&nbsp;&nbsp;人</td>
                            <td><input type="text" v-model="params.name" value="" id="consignee" class="ip_t"></td>
                        </tr>
                        <tr>
                            <td>手机号码</td>
                            <td><input type="text" v-model="params.tel" value="" id="mobile" class="ip_t"></td>
                        </tr>
                        <tr>
                            <td>省&nbsp;&nbsp;市&nbsp;&nbsp;区</td>
                            <td>
                                <div class="regn" id="regn">
                                    <!-- <pc-cascader></pc-cascader> -->
                                    <el-select v-model="Province" @change="choseProvinces" placeholder="省级地区">
                                        <el-option v-for="item in Provinces" :key="item.id" :label="item.name" :value="item.name"></el-option>
                                    </el-select>
                                    <el-select v-model="city" @change="choseCities" placeholder="市级地区">
                                        <el-option v-for="item in city1" :key="item.id" :label="item.name" :value="item.name"></el-option>
                                    </el-select>
                                    <el-select v-model="area" @change="choseBlock" placeholder="区级地区">
                                        <el-option v-for="item in area1" :key="item.id" :label="item.name" :value="item.name"></el-option>
                                    </el-select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>街道地址</td>
                            <td><input type="text" v-model="params.address" value="" placeholder="镇、街道、小区名、门牌号" id="address" class="ip_t w350" size="80"></td>
                        </tr>
                        <!-- <tr>
                            <td></td>
                            <td>
                                <label class="f14 c3">
                                    <input name="default" id="moren" type="checkbox" class="checkb" value="1"> 设置为默认收货地址
                                </label>
                            </td>
                        </tr> -->
                        <tr>
                            <td>&nbsp;</td>
                            <td>
                                <input type="hidden" name="address_id" value="0">
                                <p class="gbtn" @click="onSave">添加</p>
                                <p class="lh30">&nbsp;</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
// import Cascader from '../common/cascader.vue'
import axios from 'axios'
export default {
    components:{
        // "pc-cascader":Cascader
    },
    data(){
        return {
            Provinces:'',
            Province: '',
            city: '',
            city1: [],
            area: '',
            area1: [],
            cities:'',
            block:'',
            params: {
                name: "",
                tel: "",
                address: "",
                town: "",
                house: "" //门牌号
            },
        }
    },
    created:function(){
        this.getcitiesData()
    },
    methods:{
        // 加载china地点数据，三级
        getcitiesData(){
            this.$api.getUser.get_addresslist({}).then(res=>{
                if (res.code == 200) {
                    var addData = res.result;
                    this.Provinces = []
                    this.cities = []
                    this.block = []
                    // 省市区数据分类
                    addData.forEach((item,index)=>{
                        if(item.level == 1){
                            this.Provinces.push(item)
                        }else if(item.level == 2){
                            this.cities.push(item)
                        }else{
                            this.block.push(item)
                        }
                    })
                    this.Provinces.forEach((item3,index3)=>{
                        this.cities.forEach((item4,index4)=>{
                            if (item3.id.slice(0, 2) === item4.id.slice(0, 2)) {
                                item3.children.push(item4)
                            }
                        })
                    })
                    this.cities.forEach((item5,index5)=>{
                        this.block.forEach((item6,index6)=>{
                            if (item6.id.slice(0, 4) === item5.id.slice(0, 4)) {
                                item5.children.push(item6)
                            }
                        })
                    })
                }else{
                    console.log(res.status)
                }
            })
        },
        // 选省
        choseProvinces(e){
            var arr = this.Provinces;
            arr.forEach((item1,index)=>{
                if (e === item1.name) {
                    this.city1 = item1.children
                    this.city = item1.children[0].name
                    this.area1 =item1.children[0].children
                    this.area = item1.children[0].children[0].name
                    this.E = this.area1[0].name
                }
            })
        },
        // 选市
        choseCities(e){
            var arr = this.city1;
            arr.forEach((item2,index)=>{
                if (e === item2.name) {
                    this.area1 = item2.children
                    this.area = item2.children[0].name
                    this.E = this.area1[0].name
                }
            })
        },
        // 选区
        choseBlock(e){
            this.E=e;
            // console.log(this.E)
        },
        onSave () {
            var value = this.params.tel;
            let reg = /^1[3|4|5|7|8][0-9]{9}$/;
            if (!reg.test(value) || value === ""){
                this.$alert('请输入正确的手机号码!!!', '提示', {
                    confirmButtonText: '确定',
                });
            }else{
                var params = this.params;
                if (this.map_show == true) {
                    return;
                }
                params.province = this.Province;
                params.city = this.city;
                params.area = this.area;
                params.uid = JSON.parse(window.localStorage.getItem("user")).id;
                params.address = (params.address || "") + (params.house || "");
                this.$api.getUser.addAress(params).then(res => {
                    if (res.code == 200) {
                        this.$alert('添加成功', '提示', {
                            confirmButtonText: '确定',
                        });
                        this.$router.go(-1);
                    }
                });
            }
            
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/address/add.vue